import apiClient from './apiClient';

export async function myReferrals() {
  return apiClient('/referrals/me');
}
